<template>
  <div class="progress w-full h-20px flex items-center">
    <div class="progress-content w-full h-6px" :style="{ background: bgColor }">
      <div class="progress-fill h-full relative" :style="{ width: `${percentage}%`, '--start-color': startColor, '--end-color': endColor}">
        <div class="point w-20px h-20px absolute right-[-7px] top-[-7px]"></div>
      </div>
    </div> 
  </div>
</template>

<script>
export default {
  name: 'Progress',
  props: {
    percentage: {
      type: Number,
      default: 20,
    },
    startColor: {
      type: String,
      default: '#019CFF',
    },
    endColor: {
      type: String,
      default: '#019CFF',
    },
    bgColor: {
      type: String,
      default: '#0F393F',
    },
  },

  data() {
    return {
      
    };
  },

  mounted() {
    
  },

  methods: {
    
  },
};
</script>
<style scoped lang="scss">
.progress {
  .progress-fill {
    background: linear-gradient(90deg, var(--start-color) 0%, var(--end-color) calc(100% - 10px), transparent calc(100% - 10px) 100%);
    .point {
      border-radius: 50%;
      border: 1px solid var(--end-color);
      &::after {
        content: '';
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 8px;
        height: 8px;
        border-radius: 50%;
        background-color: #fff;
        box-shadow: 0 0 6px 2px var(--end-color);
      }
    }
  }
}
</style>